/*
---------------------------------------------------------
Copyright © 2026 Daniel Woik (DW E-Commerce). All rights reserved.
Custom-coded by DW E-Commerce. This code is licensed for use on
this store only, as part of the DW E-Commerce optimization service.
Copying, reselling, redistributing or using it on any other store
is not permitted without written permission.
---------------------------------------------------------
DW Kit:   Product Core
Version:  1.0.0
Updated:  2026-10-14 — First version: variant sync and drawers for the DW product page blocks in any theme.
Source:   DW-Component-Library/Kits/Product-Core

FUNCTION LOCKED. Install unchanged. No theme code is imported; only
Shopify's Section Rendering API is used.

Loaded by every DW product page block (price, variant picker, buy
buttons, drawer tabs). Safe to load more than once.

1. Variant sync
   - The DW variant picker asks Shopify for its own section with the
     chosen option values, then tells every DW block in that section.
   - A variant change made by the theme's own picker is picked up too:
     Horizon "variant:update", Prestige/Impact/Focal "variant:change",
     and a plain change of the product form's [name="id"] field.
   - After a DW change the theme is told the same way (Horizon and
     Prestige events), so the theme's gallery, sticky bar and buttons
     follow the DW picker.
   - Every element with data-dw-variant-swap="<selectors>" inside the
     section gets those parts replaced from the new HTML.
   - Every product form in the section gets the new variant id.
   - Event on document: dw:variant:change
       detail: { sectionId, variant (null = combination does not
       exist), doc (the rendered section), source }
2. Drawers
   [data-dw-drawer-open="<dialog id>"] opens <dialog class="dw-drawer">,
   [data-dw-drawer-close] or a click on the page overlay closes it.
   Page overlay 20% black, page scroll locked while open.
3. Buy buttons
   Quantity steppers [data-dw-qty] and the add-to-cart label/state of
   [data-dw-buy]. The add itself is a plain product form; the DW cart
   drawer adds it and opens (without it, the cart page opens).
---------------------------------------------------------
*/
(function () {
  if (window.DWProduct) return;

  /* ---------- Base styles (drawers) ---------- */
  var css =
    'dialog.dw-drawer{position:fixed;inset:0 0 0 auto;width:min(420px,100vw);max-width:100vw;height:100%;max-height:100dvh;margin:0 0 0 auto;padding:40px 20px 20px;border:0;border-radius:0;background:#fff;color:#1a1a1a;box-shadow:0 8px 24px rgba(0,0,0,.12);overflow-y:auto;overscroll-behavior:contain;box-sizing:border-box}' +
    'dialog.dw-drawer[open]{animation:dw-drawer-in .25s ease forwards}' +
    'dialog.dw-drawer.dw-drawer--closing{animation:dw-drawer-out .25s ease forwards}' +
    'dialog.dw-drawer::backdrop{background:rgba(0,0,0,.2)}' +
    '.dw-drawer__close{position:absolute;top:8px;right:8px;display:inline-flex;align-items:center;justify-content:center;width:44px;height:44px;margin:0;padding:0;border:0;border-radius:0;background:transparent;color:inherit;box-shadow:none;cursor:pointer;opacity:.8}' +
    '.dw-drawer__close:hover{opacity:1}' +
    '.dw-drawer__close svg{width:18px;height:18px}' +
    'html.dw-drawer-lock,html.dw-drawer-lock body{overflow:hidden}' +
    '@media screen and (min-width:750px){dialog.dw-drawer{padding:48px}}' +
    '@media (prefers-reduced-motion:reduce){dialog.dw-drawer[open],dialog.dw-drawer.dw-drawer--closing{animation:none}}' +
    '@keyframes dw-drawer-in{from{transform:translateX(100%)}to{transform:translateX(0)}}' +
    '@keyframes dw-drawer-out{from{transform:translateX(0)}to{transform:translateX(100%)}}';
  var style = document.createElement('style');
  style.setAttribute('data-dw-product-core', '');
  style.textContent = css;
  document.head.appendChild(style);

  /* ---------- Helpers ---------- */
  function sectionIdOf(el) {
    var s = el && el.closest ? el.closest('[id^="shopify-section-"]') : null;
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  function sectionEl(sectionId) {
    return document.getElementById('shopify-section-' + sectionId);
  }

  var cache = {};
  function load(url) {
    if (!cache[url]) {
      cache[url] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('DW product: ' + r.status);
          return r.text();
        })
        .then(function (text) {
          return new DOMParser().parseFromString(text, 'text/html');
        })
        .catch(function (err) {
          delete cache[url];
          throw err;
        });
    }
    return cache[url];
  }

  function sectionUrl(productUrl, sectionId, params) {
    var url = new URL(productUrl, window.location.origin);
    Object.keys(params).forEach(function (k) {
      url.searchParams.set(k, params[k]);
    });
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function readVariant(doc) {
    var script = doc && doc.querySelector('script[data-dw-variant-json]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent) || null;
    } catch (e) {
      return null;
    }
  }

  function keyOf(el) {
    if (!el || el === document.body) return null;
    if (el.id) return '#' + CSS.escape(el.id);
    if (el.dataset && el.dataset.inputId) return '[data-input-id="' + el.dataset.inputId + '"]';
    return null;
  }

  /* Replace the listed parts of el (or all of it) with the same parts from doc. */
  function swap(el, doc) {
    if (!el.id || !doc) return;
    var fresh = doc.getElementById(el.id);
    if (!fresh) return;
    var selectors = el.getAttribute('data-dw-variant-swap');
    var focusKey = el.contains(document.activeElement) ? keyOf(document.activeElement) : null;
    if (!selectors) {
      el.innerHTML = fresh.innerHTML;
    } else {
      var oldParts = el.querySelectorAll(selectors);
      var newParts = fresh.querySelectorAll(selectors);
      oldParts.forEach(function (part, i) {
        if (newParts[i]) part.innerHTML = newParts[i].innerHTML;
      });
    }
    if (focusKey) {
      var target = el.querySelector(focusKey);
      if (target) target.focus({ preventScroll: true });
    }
  }

  var current = {};

  /* ---------- Apply a variant to a section ---------- */
  function apply(sectionId, variant, doc, source, options) {
    options = options || {};
    var root = sectionEl(sectionId);
    if (!root) return;
    var previous = current[sectionId] || null;
    current[sectionId] = variant;

    if (variant) {
      root.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (input) {
        if (String(input.value) !== String(variant.id)) {
          if (input.tagName === 'SELECT' && !input.querySelector('option[value="' + variant.id + '"]')) return;
          input.value = variant.id;
        }
        input.disabled = false;
      });
      if (options.updateUrl) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({ path: url.toString() }, '', url.toString());
      }
    }

    root.querySelectorAll('[data-dw-variant-swap]').forEach(function (el) {
      if (el.closest('[data-dw-no-swap]')) return;
      swap(el, doc);
    });

    updateBuyButtons(root, variant);

    document.dispatchEvent(
      new CustomEvent('dw:variant:change', {
        detail: { sectionId: sectionId, variant: variant, previousVariant: previous, doc: doc, source: source }
      })
    );

    /* Tell the theme, so its gallery, sticky bar and own blocks follow. Marked dw so we never answer ourselves. */
    if (options.notifyTheme && variant) {
      var picker = options.picker || root;
      picker.dispatchEvent(
        new CustomEvent('variant:update', {
          bubbles: true,
          detail: {
            dw: true,
            resource: variant,
            sourceId: picker.id,
            data: { html: doc, productId: options.productId, newProduct: undefined }
          }
        })
      );
      root.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        if (form.closest('[data-dw-buy]')) return;
        form.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { dw: true, formId: form.id, variant: variant, previousVariant: previous }
          })
        );
      });
      if (window.Shopify && Shopify.PaymentButton && Shopify.PaymentButton.init) {
        try { Shopify.PaymentButton.init(); } catch (e) {}
      }
    }
  }

  /* ---------- DW variant picker ---------- */
  function onPickerChange(picker) {
    var sectionId = picker.getAttribute('data-dw-product-section') || sectionIdOf(picker);
    var productUrl = picker.getAttribute('data-dw-product-url');
    if (!sectionId || !productUrl) return;

    var ids = [];
    var names = [];
    var connectedUrl = null;
    picker.querySelectorAll('.dw-product-variant-picker__option').forEach(function (option) {
      var chosen = option.querySelector('input:checked') || (option.querySelector('select') && option.querySelector('select').selectedOptions[0]);
      if (!chosen) return;
      if (chosen.dataset.optionValueId) ids.push(chosen.dataset.optionValueId);
      names.push(chosen.value);
      var connected = chosen.dataset.connectedProductUrl;
      if (connected) {
        try {
          if (new URL(connected, window.location.origin).pathname !== new URL(productUrl, window.location.origin).pathname) connectedUrl = connected;
        } catch (e) {}
      }
    });

    /* Combined listings: the option belongs to another product. */
    if (connectedUrl) {
      window.location.href = connectedUrl;
      return;
    }

    picker.setAttribute('aria-busy', 'true');
    load(sectionUrl(productUrl, sectionId, { option_values: ids.join(',') }))
      .then(function (doc) {
        var fresh = doc.getElementById(picker.id);
        var variant = readVariant(fresh || doc);
        /* Shopify falls back to the first available variant when the combination does not exist. */
        if (variant && variant.options && variant.options.join('|') !== names.join('|')) variant = null;
        apply(sectionId, variant, doc, picker, {
          updateUrl: picker.getAttribute('data-template-product-match') === 'true',
          notifyTheme: true,
          picker: picker,
          productId: picker.getAttribute('data-product-id')
        });
      })
      .catch(function () {})
      .finally(function () {
        picker.removeAttribute('aria-busy');
      });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var picker = target.closest('[data-dw-variant-picker]');
    if (picker) {
      onPickerChange(picker);
      return;
    }
    /* Themes that only change the product form's id field. */
    if (target.matches('form[action*="/cart/add"] [name="id"]') && !target.closest('[data-dw-buy]')) {
      fromTheme(target, target.value, null);
    }
  });

  /* ---------- Variant changes made by the theme ---------- */
  function fromTheme(target, variantId, variant, html) {
    if (!variantId) return;
    var sectionId = sectionIdOf(target);
    if (!sectionId) {
      var any = document.querySelector('[data-dw-product-section]');
      sectionId = any && any.getAttribute('data-dw-product-section');
    }
    var root = sectionId && sectionEl(sectionId);
    if (!root) return;
    var block = root.querySelector('[data-dw-product-url]');
    if (!block) return;
    if (current[sectionId] && String(current[sectionId].id) === String(variantId)) return;

    var useHtml = html && html.querySelector && html.querySelector('[data-dw-product-url]') ? Promise.resolve(html) : null;
    (useHtml || load(sectionUrl(block.getAttribute('data-dw-product-url'), sectionId, { variant: variantId })))
      .then(function (doc) {
        apply(sectionId, variant || readVariant(doc), doc, target, {});
      })
      .catch(function () {});
  }

  ['variant:update', 'variant:change'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var d = event.detail || {};
      if (d.dw) return;
      var variant = d.variant || d.resource || null;
      if (!variant || !variant.id) return;
      fromTheme(event.target, variant.id, variant, d.data && d.data.html);
    });
  });

  /* ---------- Buy buttons ---------- */
  function updateBuyButtons(root, variant) {
    root.querySelectorAll('[data-dw-buy]').forEach(function (buy) {
      var button = buy.querySelector('[data-dw-buy-add]');
      var label = buy.querySelector('[data-dw-buy-label]');
      var idInput = buy.querySelector('[name="id"]');
      var text = buy.getAttribute('data-label-add');
      if (!variant) text = buy.getAttribute('data-label-unavailable');
      else if (!variant.available) text = buy.getAttribute('data-label-sold-out');
      if (label) label.textContent = text;
      if (button) button.disabled = !variant || !variant.available;
      if (idInput) idInput.disabled = !variant;
      buy.classList.toggle('dw-buy--unavailable', !variant || !variant.available);
      var qty = buy.querySelector('.dw-buy__qty-input');
      if (qty && variant && variant.quantity_rule) {
        qty.min = variant.quantity_rule.min || 1;
        qty.step = variant.quantity_rule.increment || 1;
        if (variant.quantity_rule.max) qty.max = variant.quantity_rule.max;
        else qty.removeAttribute('max');
        if (Number(qty.value) < Number(qty.min)) qty.value = qty.min;
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var stepper = target.closest('[data-dw-qty]');
    if (stepper) {
      event.preventDefault();
      var input = stepper.parentNode.querySelector('.dw-buy__qty-input');
      if (!input) return;
      var step = Number(input.step) || 1;
      var min = Number(input.min) || 1;
      var max = input.max ? Number(input.max) : Infinity;
      var next = (Number(input.value) || min) + step * Number(stepper.getAttribute('data-dw-qty'));
      input.value = Math.min(max, Math.max(min, next));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* ---------- Drawers ---------- */
    var opener = target.closest('[data-dw-drawer-open]');
    if (opener) {
      event.preventDefault();
      openDrawer(document.getElementById(opener.getAttribute('data-dw-drawer-open')), opener);
      return;
    }
    var closer = target.closest('[data-dw-drawer-close]');
    if (closer) {
      event.preventDefault();
      closeDrawer(closer.closest('dialog.dw-drawer'));
      return;
    }
    /* A click on the page overlay lands on the dialog element itself. */
    if (target.matches('dialog.dw-drawer[open]')) {
      var r = target.getBoundingClientRect();
      var inside = event.clientX >= r.left && event.clientX <= r.right && event.clientY >= r.top && event.clientY <= r.bottom;
      if (!inside) closeDrawer(target);
    }
  });

  function openDrawer(dialog, opener) {
    if (!dialog || dialog.open || typeof dialog.showModal !== 'function') return;
    dialog._dwOpener = opener || null;
    dialog.classList.remove('dw-drawer--closing');
    dialog.showModal();
    document.documentElement.classList.add('dw-drawer-lock');
  }

  function closeDrawer(dialog) {
    if (!dialog || !dialog.open || dialog.classList.contains('dw-drawer--closing')) return;
    var done = false;
    function finish() {
      if (done) return;
      done = true;
      dialog.classList.remove('dw-drawer--closing');
      dialog.close();
    }
    dialog.classList.add('dw-drawer--closing');
    dialog.addEventListener('animationend', finish, { once: true });
    window.setTimeout(finish, 350);
  }

  document.addEventListener(
    'cancel',
    function (event) {
      var dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('dw-drawer')) return;
      event.preventDefault();
      closeDrawer(dialog);
    },
    true
  );

  document.addEventListener(
    'close',
    function (event) {
      var dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement) || !dialog.classList.contains('dw-drawer')) return;
      if (!document.querySelector('dialog.dw-drawer[open]')) document.documentElement.classList.remove('dw-drawer-lock');
      if (dialog._dwOpener && dialog._dwOpener.isConnected) dialog._dwOpener.focus({ preventScroll: true });
    },
    true
  );

  /* ---------- Start values ---------- */
  function init() {
    document.querySelectorAll('[data-dw-buy], [data-dw-variant-picker]').forEach(function (el) {
      var sectionId = el.getAttribute('data-dw-product-section') || sectionIdOf(el);
      if (!sectionId || current[sectionId]) return;
      var script = el.querySelector('script[data-dw-variant-json]');
      if (!script) return;
      try {
        current[sectionId] = JSON.parse(script.textContent) || null;
      } catch (e) {}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () {
    current = {};
    cache = {};
    init();
  });

  window.DWProduct = { apply: apply, swap: swap, openDrawer: openDrawer, closeDrawer: closeDrawer };
})();
